/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHierarchyTabs = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M1 1h15v6H5v4h3V9h15v6H8v-2H5v6h3v-2h15v6H8v-2H5v1H3V7H1zm2 4h11V3H3zm7 6v2h11v-2zm0 10h11v-2H10z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHierarchyTabs as HierarchyTabs };
